var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Renderer2 } from '@angular/core';
import { ReplyAbstractComponent } from '@app/shared/components/reply/reply-abstract.component';
import { DomSanitizer } from '@angular/platform-browser';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
import { SocketService } from '@app/core/socket.service';
var MersenneTwister = require('mersennetwister');
var ReplyRouletteComponent = /** @class */ (function (_super) {
    __extends(ReplyRouletteComponent, _super);
    function ReplyRouletteComponent(socket, sanitizer, renderer, balanceHistory) {
        var _this = _super.call(this, socket, balanceHistory) || this;
        _this.socket = socket;
        _this.sanitizer = sanitizer;
        _this.renderer = renderer;
        _this.balanceHistory = balanceHistory;
        _this.data = null;
        _this.deg = 0;
        _this.fields = [];
        _this.bonusWheel = false;
        _this.fields = [
            { value: 11, color: 'black' },
            { value: 4, color: 'red' },
            { value: 17, color: 'black' },
            { value: 10, color: 'red' },
            { value: 19, color: 'black' },
            { value: 2, color: 'red' },
            { value: 13, color: 'black' },
            { value: 21, color: 'bonus' },
            { value: 8, color: 'red' },
            { value: 3, color: 'black' },
            { value: 18, color: 'red' },
            { value: 5, color: 'black' },
            { value: 12, color: 'red' },
            { value: 15, color: 'black' },
            { value: 6, color: 'red' },
            { value: 9, color: 'black' },
            { value: 16, color: 'red' },
            { value: 1, color: 'black' },
            { value: 0, color: 'skull' },
            { value: 20, color: 'red' },
            { value: 7, color: 'black' },
            { value: 14, color: 'red' },
        ];
        return _this;
    }
    // specified game
    ReplyRouletteComponent.prototype.initialize = function (data) {
        if (data) {
            if (data.game !== 'roulette') {
                this._error = true;
                return;
            }
            this.data = data.gameData;
            this._loading = false;
        }
        // const randomNumber: number = this.generateRandomNumber(this.playerSeed, this.serverSeed, 22);
        // this.field = this.searchField(randomNumber);
        // this.deg = (360 / this.fields.length) * this.field.index;
        this.generateGame();
    };
    // not specified game
    ReplyRouletteComponent.prototype.generateGame = function () {
        var randomNumber = this.generateRandomNumber(this.playerSeed, this.serverSeed, 22);
        this.field = this.searchField(randomNumber);
        if (this.field.color === 'bonus') {
            this.bonusWheel = true;
            randomNumber = this.generateRandomNumber(this.serverSeed, this.playerSeed, 11);
            this.deg = (360 / 11) * randomNumber;
        }
        else {
            this.bonusWheel = false;
            this.deg = (360 / this.fields.length) * this.field.index;
        }
        this._loading = false;
    };
    ReplyRouletteComponent.prototype.generateRandomNumber = function (clientSeed, serverSeed, toNumber) {
        clientSeed = clientSeed.replace('0x', '');
        serverSeed = serverSeed.replace('0x', '');
        var clSeedSplitted = clientSeed.match(/.{1,6}/g);
        var srvSeedSplitted = serverSeed.match(/.{1,6}/g);
        var seedsCombined = clSeedSplitted.concat(srvSeedSplitted);
        for (var i = 0; i < seedsCombined.length; i++) {
            seedsCombined[i.toString()] = parseInt(seedsCombined[i], 16);
        }
        var mt = new MersenneTwister();
        mt.seedArray(seedsCombined);
        return mt.int() % toNumber;
    };
    ReplyRouletteComponent.prototype.searchField = function (randomNumber) {
        var obj = this.fields.find(function (field, index) {
            if (field.value === randomNumber) {
                field.index = index;
                return field;
            }
        });
        return obj;
    };
    return ReplyRouletteComponent;
}(ReplyAbstractComponent));
export { ReplyRouletteComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-roulette.component.ts.pre-build-optimizer.js